/*
  Entwurf D (Produktseite mit Kaufbox) – nur auf product.kaufbox.json geladen.

  Eine Zahl (Anzahl Stühle) für alles: Mengen-Kacheln, − / + neben dem
  Warenkorb-Button, Preis unter dem Titel, Tabelle „Mengenrabatt im Überblick“,
  Lifestyle-Band und Sticky-Leiste des Themes.

  Kauf-Logik wie die Kaufbox (snippets/product-kaufbox.liquid): Jede Kachel ist
  eine echte Variante („Stuhl“, „2er-Set“ …); die Kachel wählt die Variante im
  ausgeblendeten Varianten-Picker des Themes. Eine Anzahl ohne eigenes Set läuft
  als Einzelstuhl × Anzahl, der Rabatt kommt dann vom automatischen Rabatt im
  Warenkorb.
*/
(function () {
  if (window.__kaufboxD) return;
  window.__kaufboxD = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Texte in der Sprache der Seite: <script type="application/json" data-kbd-i18n>
  // (snippets/kaufbox-d-i18n.liquid, locales/*.json → kaufbox_d.*). Deutsch als Rückfall.
  var T = {
    chairOne: '1 Stuhl',
    chairOther: '{n} Stühle',
    moreTitle: 'Andere Anzahl?',
    moreHint: 'Unten mit − / + wählen',
    saveVsSingle: 'Sie sparen {amount} gegenüber dem Einzelpreis',
    perChair: '{chairs} · je Stuhl {price}',
    save: 'Sie sparen {amount} ({percent}% Mengenrabatt)',
    times: '{n} × {price}',
    qtyLabel: 'Anzahl',
    qtyLess: 'Einen weniger',
    qtyMore: 'Einen mehr',
    unitPieces: 'Stück'
  };
  (function loadTexts() {
    var el = document.querySelector('script[data-kbd-i18n]');
    if (!el) return;
    var data;
    try { data = JSON.parse(el.textContent); } catch (e) { return; }
    // Liquid escaped Übersetzungen ggf. (&#39; usw.) – für textContent zurückwandeln.
    var dec = document.createElement('textarea');
    Object.keys(T).forEach(function (k) {
      if (typeof data[k] !== 'string' || !data[k]) return;
      dec.innerHTML = data[k];
      T[k] = dec.value;
    });
  })();
  function fmt(str, vals) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return vals[k] != null ? vals[k] : m; });
  }

  // Geld ohne Leerzeichen vor dem €: 1.305,30€
  function eur(cents) {
    cents = Math.round(cents);
    var neg = cents < 0;
    cents = Math.abs(cents);
    var e = Math.floor(cents / 100), ct = cents % 100;
    return (neg ? '−' : '') + String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + (ct < 10 ? '0' : '') + ct + '€';
  }
  function chairs(n) { return n === 1 ? fmt(T.chairOne, { n: n }) : fmt(T.chairOther, { n: n }); }
  // Gratis-Versand-Aktion (snippets/kaufbox-d-promo-ship.liquid): Text nach der
  // gewählten Anzahl; beim Ledermuster ausgeblendet. Ob die Aktion läuft,
  // entscheidet html[data-promotion-state] (assets/kaufbox-d.css).
  function updatePromoShip(ctx, q, sample) {
    qsa('[data-kbd-promo-ship]', ctx).forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 0;
      var on = !sample && min > 0 && q >= min;
      el.hidden = !!sample;
      el.classList.toggle('is-on', on);
      var t = el.querySelector('[data-kbd-promo-ship-t]');
      if (t) t.textContent = on ? el.dataset.on : el.dataset.off;
    });
  }
  // Ledermuster-Variante am Titel erkennen (DE/FR/EN; nur ohne Mengen-Kacheln).
  var SAMPLE_RE = /ledermuster|échantillon|echantillon|leather sample/i;
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  // Preis unter dem Titel steht ggf. zweimal: im Block „D: Bewertung + Preis“
  // ([data-kbd-head]) und auf dem Handy als Kopie über der Galerie
  // (snippets/kaufbox-d-mobile-head.liquid, ohne data-kbd-head). Beide gleich setzen.
  function setText(sel, ctx, text) { qsa(sel, ctx).forEach(function (el) { el.textContent = text; }); }
  function scrollToEl(el, block) {
    if (!el) return;
    try { el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: block || 'start' }); }
    catch (e) { el.scrollIntoView(); }
  }
  function focusNoScroll(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { /* ältere Browser */ }
  }

  /* ---------- Empfehlungen: alte Set-Produkte ausblenden ----------
     Auf dieser Vorlage sind 2er- bis 8er-Sets Varianten des Stuhls (Kacheln);
     die alten Set-Produkte (Handle „…-sets“ bzw. „…-set“, Titel „… - Sets“)
     gehören dann nicht in „Ähnliche Produkte“. Das Theme lädt die Empfehlungen
     per fetch (section_id=api-product-recommendation, assets/theme.js) erst bei
     DOMContentLoaded – dieses Skript (defer) läuft vorher und filtert die
     Antwort, bevor das Theme sie einsetzt: Anzahl, Slider und „keine
     Empfehlungen“ (Section ausblenden) stimmen so. Das Skript lädt nur auf
     product.kaufbox.json, andere Vorlagen bleiben unverändert. */
  function isSetProductUrl(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return !!m && /-sets?$/i.test(decodeURIComponent(m[1]));
  }
  (function filterRecommendations() {
    if (!window.fetch || typeof window.Response !== 'function' || typeof window.DOMParser !== 'function') return;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var p = origFetch.apply(window, arguments);
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (String(url).indexOf('section_id=api-product-recommendation') === -1) return p;
      return p.then(function (res) {
        if (!res || !res.ok) return res;
        return res.clone().text().then(function (html) {
          try {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var tpl = doc.querySelector('[data-api-related-template]');
            var box = tpl && (tpl.content || tpl);
            if (!box) return res;
            var removed = 0;
            qsa('[data-grid-item]', box).forEach(function (item) {
              var link = item.querySelector('a[href*="/products/"]');
              if (link && isSetProductUrl(link.getAttribute('href'))) {
                item.parentNode.removeChild(item);
                removed++;
              }
            });
            if (!removed) return res;
            // Wie snippets/products-recommendation.liquid: bis 4 Produkte kein Slider.
            var grid = box.querySelector('[data-grid-slider]');
            if (grid && qsa('[data-grid-item]', box).length <= 4) grid.classList.add('grid--slider-disabled');
            return new Response('<!doctype html>' + doc.documentElement.outerHTML, {
              status: res.status,
              statusText: res.statusText,
              headers: { 'Content-Type': res.headers.get('Content-Type') || 'text/html; charset=utf-8' }
            });
          } catch (e) {
            return res;
          }
        }, function () { return res; });
      });
    };
  })();

  function init() {
    initColorLinks();
    initAccordionLinks();
    initKaufbox();
  }

  /* ---------- Farbwahl: aktuelle Query (z. B. preview_theme_id) mitnehmen ---------- */
  function initColorLinks() {
    var params = new URLSearchParams(window.location.search);
    params.delete('variant');
    var qs = params.toString();
    qsa('a[data-kbd-color]').forEach(function (a) {
      if (a.getAttribute('aria-current') === 'true') {
        a.addEventListener('click', function (e) { e.preventDefault(); });
        return;
      }
      if (!qs) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      a.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + qs);
    });
  }

  /* ---------- „Alle Produktdetails“, „Versandkosten“: hinscrollen, Akkordeon öffnen ----------
     Ziel ist ein <details> (öffnen, Fokus auf die Zeile) oder eine Section
     (Fokus auf das Element mit data-kbd-focus, z. B. die Überschrift). */
  function openAcc(id) {
    var d = id && document.getElementById(id);
    if (!d) return false;
    var isAcc = d.tagName === 'DETAILS';
    if (isAcc) d.open = true;
    scrollToEl(d, 'start');
    focusNoScroll(isAcc ? d.querySelector('summary') : (d.querySelector('[data-kbd-focus]') || d));
    return true;
  }
  function initAccordionLinks() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-kbd-acc]');
      if (a) {
        var id = (a.getAttribute('href') || '').replace(/^#/, '');
        if (openAcc(id)) e.preventDefault();
        return;
      }
      var j = e.target.closest && e.target.closest('a[data-kbd-jump]');
      if (j) {
        var t = document.getElementById((j.getAttribute('href') || '').replace(/^#/, ''));
        if (t) { e.preventDefault(); scrollToEl(t, 'start'); }
      }
    });
  }

  // Bestand für − / +: Zahl aus „Nur noch X übrig“ auf der Seite, sonst 99.
  function capFromBadge(section) {
    var badge = section.querySelector('[data-inventory-badge]');
    var m = badge && badge.textContent.match(/(\d+)/);
    var c = m ? parseInt(m[1], 10) : 99;
    return c > 0 ? c : 99;
  }

  /* ---------- Sticky-Leiste des Themes (#cart-bar, Button mit data-cart-bar-scroll) ----------
     Ein Tipp löst den Warenkorb-Button der Seite aus – gleiche Variante, Anzahl und Eigenschaften
     wie ein Tipp auf den Button selbst (Theme: product-form → theme:cart:add). Ohne aktiven Button
     (ausverkauft) geht es zur Kaufbox. Capture-Phase: vor dem Theme, das sonst nur hochscrollt.
     Fehler beim Hinzufügen (z. B. Bestand) stehen am Formular – dann dorthin scrollen. */
  function bindCartBar(getForm, fallback) {
    var fromBar = false;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('#cart-bar [data-cart-bar-scroll]');
      if (!b) return;
      var f = getForm();
      var atc = f && f.querySelector('[data-add-to-cart]');
      e.preventDefault();
      e.stopPropagation();
      if (atc && !atc.disabled) { fromBar = true; atc.click(); }
      else fallback();
    }, true);
    document.addEventListener('theme:product:add', function () { fromBar = false; });
    document.addEventListener('theme:product:add-error', function () {
      if (!fromBar) return;
      fromBar = false;
      var f = getForm();
      scrollToEl(f && (f.querySelector('[data-cart-errors-container]') || f), 'center');
    });
  }

  /* ---------- Ohne Einzelstuhl-Variante (z. B. Sessel, Tisch) ----------
     Keine Mengen-Kacheln. − / + ist dann ein normales Mengenfeld, der Preis
     oben zeigt Variante × Anzahl und folgt dem Varianten-Picker des Themes. */
  function initPlain() {
    var head = document.querySelector('[data-kbd-head]');
    var qtyBox = document.querySelector('[data-kbd-qty]');
    var f = qtyBox && qtyBox.closest('form');
    if (!head && !f) return;

    var section = (qtyBox || head).closest('.shopify-section') || document;
    var price = head ? parseInt(head.dataset.price, 10) : NaN;
    var label = head ? (head.dataset.label || '') : '';
    var q = 1;
    var isSample = SAMPLE_RE.test(label);
    var cap = parseInt(qtyBox && qtyBox.dataset.stock, 10);
    if (!(cap > 0)) cap = capFromBadge(section);

    var input = qtyBox && qtyBox.querySelector('[data-kbd-input]');
    var minus = qtyBox && qtyBox.querySelector('[data-kbd-minus]');
    var plus = qtyBox && qtyBox.querySelector('[data-kbd-plus]');
    var hint = section.querySelector('[data-kbd-qty-hint]');
    if (qtyBox) {
      qtyBox.setAttribute('aria-label', T.qtyLabel);
      if (input) { input.setAttribute('aria-label', T.qtyLabel); input.max = String(cap); }
      if (minus) minus.setAttribute('aria-label', T.qtyLess);
      if (plus) plus.setAttribute('aria-label', T.qtyMore);
    }
    if (hint) {
      var capEl = hint.querySelector('[data-kbd-cap]');
      var unitEl = hint.querySelector('[data-kbd-cap-unit]');
      if (capEl) capEl.textContent = cap;
      if (unitEl) unitEl.textContent = T.unitPieces;
    }

    function render() {
      if (qtyBox) {
        qtyBox.hidden = isSample;
        if (input) input.value = q;
        // aria-disabled statt disabled: der Fokus bleibt auf dem Button.
        if (minus) minus.setAttribute('aria-disabled', q <= 1 ? 'true' : 'false');
        if (plus) plus.setAttribute('aria-disabled', q >= cap ? 'true' : 'false');
      }
      var qf = f && f.elements.namedItem('quantity');
      if (qf && String(qf.value) !== String(q)) {
        qf.value = q;
        qf.dispatchEvent(new Event('input', { bubbles: true })); // u. a. „Angebot anfordern“-Link
      }
      if (head && price >= 0) {
        setText('[data-kbd-total]', section, eur(price * q));
        setText('[data-kbd-per]', section, q > 1 ? fmt(T.times, { n: q, price: eur(price) }) : label);
      }
      updatePromoShip(section, q, isSample);
      // Sticky-Leiste: gleicher Betrag, ohne Leerzeichen vor dem € (nach dem Theme).
      setTimeout(function () {
        var bar = document.getElementById('cart-bar');
        var bp = bar && bar.querySelector('[data-product-price]');
        var bc = bar && bar.querySelector('[data-compare-price]');
        if (bp && price >= 0) { bp.textContent = eur(price * q); bp.classList.remove('product__price--sale'); }
        if (bc) bc.textContent = '';
      }, 80);
    }
    function set(n, fromStepper) {
      n = Math.max(1, Math.min(cap, parseInt(n, 10) || 1));
      if (isSample) n = 1;
      q = n;
      render();
      if (hint) hint.hidden = !(fromStepper && q >= cap);
    }

    if (qtyBox) {
      qtyBox.addEventListener('click', function (e) {
        if (e.target.closest('[data-kbd-minus]')) { if (q > 1) set(q - 1, true); return; }
        if (e.target.closest('[data-kbd-plus]')) {
          if (q >= cap) { if (hint) hint.hidden = false; return; }
          set(q + 1, true);
        }
      });
      if (input) {
        input.addEventListener('change', function () { set(input.value, true); });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); set(input.value, true); } });
      }
    }
    if (hint) {
      hint.addEventListener('click', function (e) {
        if (!e.target.closest('[data-kbd-angebot]')) return;
        e.preventDefault();
        var real = document.querySelector('[data-angebot-link]');
        if (real && real.href) window.location.href = real.href;
      });
    }

    document.addEventListener('theme:variant:change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      if (typeof v.price === 'number') price = v.price;
      label = v.title && v.title !== 'Default Title' ? v.title : '';
      isSample = SAMPLE_RE.test(label);
      // Sessel + Ledermuster, über die Muster-URL geöffnet: zurück auf den
      // Sessel wieder „1 Sessel“ statt des Variantennamens (kaufbox-d-price).
      if (head && head.dataset.kbdMainId === String(v.id)) {
        label = head.dataset.kbdMainLabel || label;
        isSample = false;
      }
      set(q);
    });
    window.addEventListener('pageshow', function () { set(parseInt((f && f.elements.namedItem('quantity') || {}).value, 10) || 1); });
    render();
  }

  /* ---------- Kaufbox ---------- */
  function initKaufbox() {
    var root = document.querySelector('[data-kbd-box]');
    if (!root) { initPlain(); return; }

    var variants = JSON.parse(root.querySelector('[data-kbd-variants]').textContent);
    var byId = {};
    variants.forEach(function (v) { byId[String(v.id)] = v; });
    var single = byId[root.dataset.singleId];
    var setBySize = {};
    variants.forEach(function (v) { if (v.n > 1) setBySize[v.n] = v; });
    var tierSizes = qsa('[data-kbd-tile]', root).map(function (t) { return parseInt(t.dataset.n, 10); });
    var bulkPct = parseFloat(root.dataset.bulkPercent) || 0;
    var bulkMin = parseInt(root.dataset.bulkMin, 10) || 2;
    var formId = root.dataset.formId;
    var section = root.closest('.shopify-section') || document;

    // Bestand für − / +: echter Lagerbestand, wenn Shopify ihn führt; sonst die
    // Zahl aus „Nur noch X übrig“ auf der Seite; sonst 99.
    var cap = parseInt(root.dataset.stock, 10);
    if (!(cap > 0)) cap = capFromBadge(section);

    var qtyBox = section.querySelector('[data-kbd-qty]');
    // Ohne − / + (ausverkauft oder Einstellung aus) gibt es keine freie Anzahl.
    var moreTile = root.querySelector('[data-kbd-more]');
    if (!qtyBox && moreTile) moreTile.hidden = true;
    var input = qtyBox && qtyBox.querySelector('[data-kbd-input]');
    var minus = qtyBox && qtyBox.querySelector('[data-kbd-minus]');
    var plus = qtyBox && qtyBox.querySelector('[data-kbd-plus]');
    var hint = section.querySelector('[data-kbd-qty-hint]');
    if (input) input.max = String(Math.max(cap, 1));
    if (hint) {
      var capEl = hint.querySelector('[data-kbd-cap]');
      if (capEl) capEl.textContent = cap;
    }

    var busy = false;
    var state = null;

    function form() { return document.getElementById(formId); }
    function idField() { var f = form(); return f ? f.elements.namedItem('id') : null; }
    function qtyField() { var f = form(); return f ? f.elements.namedItem('quantity') : null; }
    function currentVariant() { var f = idField(); return f ? byId[String(f.value)] : null; }

    function selectVariant(v) {
      var cur = currentVariant();
      if (cur && cur.id === v.id) return;
      var radios = document.querySelectorAll('input[data-single-option-selector][form="' + formId + '"]');
      for (var i = 0; i < radios.length; i++) {
        if (radios[i].value === v.title) { radios[i].click(); return; }
      }
    }
    function setQuantity(q) {
      var f = qtyField();
      if (!f) return;
      f.value = q;
      f.dispatchEvent(new Event('input', { bubbles: true }));
      f.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function stateForQty(q) {
      if (setBySize[q] && setBySize[q].available) {
        var s = setBySize[q];
        return { q: q, variant: s, qty: 1, total: s.price, viaCart: false };
      }
      var unit = single.price;
      var discounted = q >= bulkMin ? Math.round(unit * (100 - bulkPct) / 100) : unit;
      return { q: q, variant: single, qty: q, total: discounted * q, viaCart: q >= bulkMin && bulkPct > 0 };
    }

    function render(st) {
      state = st;
      var sample = !!st.sample;
      var q = st.q || 1;
      var isTier = !sample && tierSizes.indexOf(q) > -1;
      var base = sample ? st.variant.price : single.price * q;
      var save = sample ? 0 : Math.max(0, base - st.total);
      var pct = save > 0 ? Math.round(save * 100 / base) : 0;

      // Kacheln
      qsa('[data-kbd-tile]', root).forEach(function (t) {
        t.setAttribute('aria-pressed', String(!sample && parseInt(t.dataset.n, 10) === q));
      });
      var more = root.querySelector('[data-kbd-more]');
      if (more) {
        var on = !sample && !isTier;
        more.classList.toggle('is-on', on);
        root.querySelector('[data-kbd-more-t]').textContent = on ? chairs(q) : T.moreTitle;
        root.querySelector('[data-kbd-more-s]').textContent = on ? eur(st.total) : T.moreHint;
      }
      var note = root.querySelector('[data-kbd-note]');
      if (note) note.hidden = !st.viaCart;

      // Summe in der Kaufbox
      var what = root.querySelector('[data-kbd-sum-what]');
      var sumT = root.querySelector('[data-kbd-sum-total]');
      var sumN = root.querySelector('[data-kbd-sum-note]');
      if (what) what.textContent = sample ? st.variant.title : chairs(q);
      if (sumT) sumT.textContent = eur(st.total);
      if (sumN) {
        sumN.hidden = !save;
        sumN.textContent = save ? fmt(T.saveVsSingle, { amount: eur(save) }) : '';
      }

      // − / + neben dem Warenkorb-Button
      if (qtyBox) {
        qtyBox.hidden = sample;
        if (input) input.value = q;
        // aria-disabled statt disabled: der Fokus bleibt auf dem Button.
        if (minus) minus.setAttribute('aria-disabled', q <= 1 ? 'true' : 'false');
        if (plus) plus.setAttribute('aria-disabled', q >= cap ? 'true' : 'false');
      }
      if (hint && sample) hint.hidden = true;

      // Preis unter dem Titel
      // Preis unter dem Titel (Kaufspalte + Handy-Kopie über der Galerie)
      setText('[data-kbd-total]', section, eur(st.total));
      setText('[data-kbd-per]', section, sample ? st.variant.title
        : (q === 1 ? chairs(1) : fmt(T.perChair, { chairs: chairs(q), price: eur(Math.round(st.total / q)) })));
      qsa('[data-kbd-save]', section).forEach(function (hs) {
        hs.hidden = !save;
        hs.textContent = save ? fmt(T.save, { amount: eur(save), percent: pct }) : '';
      });
      updatePromoShip(section, q, sample);

      // Tabelle „Mengenrabatt im Überblick“
      qsa('[data-kbd-row-n]').forEach(function (tr) {
        var rowOn = !sample && parseInt(tr.getAttribute('data-kbd-row-n'), 10) === q;
        tr.classList.toggle('is-on', rowOn);
        var b = tr.querySelector('[data-kbd-row]');
        if (b) b.setAttribute('aria-pressed', rowOn ? 'true' : 'false');
      });

      updateExtras(st.total, sample ? st.variant.title : chairs(q));
    }

    // Sticky-Leiste und PayPal-Hinweis: kurz nach dem Theme, sonst überschreibt
    // es die Werte beim Variantenwechsel wieder.
    function updateExtras(amount, label) {
      setTimeout(function () {
        var bar = document.getElementById('cart-bar');
        if (bar) {
          var bp = bar.querySelector('[data-product-price]');
          var bc = bar.querySelector('[data-compare-price]');
          if (bp) {
            bp.textContent = eur(amount);
            bp.classList.remove('product__price--sale');
            var n = bar.querySelector('.kbd-bar-n');
            if (!n) {
              n = document.createElement('span');
              n.className = 'kbd-bar-n';
              bp.parentNode.appendChild(n);
            }
            n.textContent = label;
          }
          if (bc) bc.textContent = '';
          var btnText = bar.querySelector('.btn__text');
          var atc = form() && form().querySelector('[data-add-to-cart]');
          if (btnText && atc) btnText.textContent = (atc.querySelector('[data-add-to-cart-text]') || atc).textContent.trim();
        }
        var pp = document.querySelector('#pp-paylater [data-pp-message]');
        if (pp) pp.setAttribute('data-pp-amount', (amount / 100).toFixed(2));
      }, 80);
    }

    // Galerie (Theme: ein Bild + Vorschaubilder): zur gewählten Anzahl das
    // passende Bild zeigen – Set-Bild der Variante; 1 Stuhl bzw. eine Anzahl
    // ohne eigenes Set (läuft als Einzelstuhl) zeigt wieder das erste Bild.
    // Nur über das Theme-Ereignis, die Reihenfolge der Bilder bleibt.
    var gallery = section.querySelector && section.querySelector('product-images');
    var smallMax = ((window.theme && theme.sizes && theme.sizes.small) || 750) - 1;
    function showMedia(st) {
      if (!gallery || !st || st.sample || !st.variant) return;
      var el = null;
      if (st.variant === single) el = gallery.querySelector('[data-image-id]');
      else if (st.variant.media) el = gallery.querySelector('[data-image-id="' + st.variant.media + '"]');
      if (!el) return;
      var key = el.getAttribute('data-media-id');
      if (!key || gallery.getAttribute('data-active-media') === key) return;
      el.dispatchEvent(new CustomEvent('theme:media:select', { bubbles: true, detail: { id: key } }));
      // Handy ohne Überblend-Galerie (Slider): hinscrollen wie das Theme.
      if (window.matchMedia('(max-width: ' + smallMax + 'px)').matches && !gallery.hasAttribute('data-fader-mobile')) {
        var list = gallery.querySelector('[data-product-media-list]');
        if (list) list.scrollTo({ left: el.offsetLeft });
      }
    }

    // fromStepper: Plus/Minus oder getippte Zahl – dann gilt der Bestand als
    // Obergrenze, und an der Grenze erscheint der Hinweis auf „Angebot anfordern“.
    function apply(q, fromStepper) {
      q = Math.max(1, Math.min(99, parseInt(q, 10) || 1));
      if (fromStepper && q > cap) q = cap;
      var st = stateForQty(q);
      busy = true;
      selectVariant(st.variant);
      setQuantity(st.qty);
      render(st);
      if (hint) hint.hidden = !(fromStepper && q >= cap);
      setTimeout(function () { busy = false; showMedia(st); }, 150);
    }

    function jumpToBuyBox() {
      var tiles = root.querySelector('[data-kbd-tiles]');
      scrollToEl(tiles, 'center');
      focusNoScroll(root.querySelector('[data-kbd-tile][aria-pressed="true"]') || tiles);
    }

    root.addEventListener('click', function (e) {
      var tile = e.target.closest('[data-kbd-tile]');
      if (tile && tile.getAttribute('aria-disabled') !== 'true') apply(tile.dataset.n);
    });

    if (qtyBox) {
      qtyBox.addEventListener('click', function (e) {
        var cur = (state && !state.sample && state.q) || 1;
        if (e.target.closest('[data-kbd-minus]')) { if (cur > 1) apply(cur - 1, cur - 1 <= cap); return; }
        if (e.target.closest('[data-kbd-plus]')) {
          if (cur >= cap) { if (hint) hint.hidden = false; plus.setAttribute('aria-disabled', 'true'); return; }
          apply(cur + 1, true);
        }
      });
      if (input) {
        input.addEventListener('change', function () { apply(input.value, true); });
        input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); apply(input.value, true); } });
      }
    }

    // „Angebot anfordern“ im Hinweis: dieselbe Adresse wie der Button. (Ohne
    // Angebot – FR/EN oder abgeschaltet – ist es ein normaler Link zur Kontaktseite.)
    if (hint) {
      hint.addEventListener('click', function (e) {
        var a = e.target.closest('[data-kbd-angebot]');
        if (!a) return;
        var real = document.querySelector('[data-angebot-link]');
        if (real && real.href) { e.preventDefault(); window.location.href = real.href; }
        else { e.preventDefault(); scrollToEl(document.querySelector('.product__actions'), 'center'); }
      });
    }

    // Tabelle und Lifestyle-Band: Anzahl setzen und zur Kaufbox scrollen.
    document.addEventListener('click', function (e) {
      var row = e.target.closest('[data-kbd-row-n]');
      var pick = e.target.closest('[data-kbd-pick]');
      var n = 0;
      if (row) {
        var rb = row.querySelector('[data-kbd-row]');
        if (rb && rb.getAttribute('aria-disabled') === 'true') return;
        n = parseInt(row.getAttribute('data-kbd-row-n'), 10);
      } else if (pick) {
        n = parseInt(pick.getAttribute('data-kbd-pick'), 10);
      }
      if (!n) return;
      apply(n);
      jumpToBuyBox();
    });

    // Sticky-Leiste: direkt in den Warenkorb – genau das, was der Button der Kaufbox einlegen würde
    // (auch das Ledermuster, wenn es gewählt ist: die Leiste zeigt dann dessen Namen und Preis).
    bindCartBar(form, jumpToBuyBox);

    // Variante von außen gewechselt (?variant=…, Theme-Logik): Zustand nachziehen.
    document.addEventListener('theme:variant:change', function (e) {
      if (busy || !e.detail || !e.detail.variant) {
        if (state) setTimeout(function () { updateExtras(state.total, state.sample ? state.variant.title : chairs(state.q)); }, 0);
        return;
      }
      syncFromVariant(byId[String(e.detail.variant.id)]);
    });

    function syncFromVariant(v) {
      if (!v) return;
      if (v.n === 0) { render({ sample: true, variant: v, total: v.price, q: 1 }); return; }
      if (v.n > 1 && !v.available) { apply(v.n); return; }
      if (v.n > 1) { render(stateForQty(v.n)); setQuantity(1); return; }
      var q = parseInt((qtyField() || {}).value, 10) || 1;
      render(stateForQty(q));
    }

    syncFromVariant(currentVariant() || single);
    window.addEventListener('pageshow', function () { syncFromVariant(currentVariant() || single); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
